import React, { useState } from 'react';
import './atelier.css';

/** Shared nav + footer for Atelier-themed public pages (landing, about). */

export const ATELIER_SCROLL_TARGET_KEY = 'atelierScrollTarget';

export const scrollToId = (id, behavior = 'smooth') => {
  document.getElementById(id)?.scrollIntoView({ behavior, block: 'start' });
};

export const AtelierNav = ({ links, onLogo, onSignIn, onStartDesigning }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const run = (fn) => () => { setMenuOpen(false); fn?.(); };

  return (
    <nav className={`atl-nav${menuOpen ? ' is-open' : ''}`}>
      <div className="atl-nav-inner atl-wrap">
        <button type="button" className="atl-link atl-logo" onClick={run(onLogo)}>
          <img className="atl-logo-mark" src="/logo.png?v=20260711" alt="" />fashdeck
        </button>
        <div className="atl-nav-links" id="atl-nav-menu">
          {links.map(([label, action, current]) => (
            <button
              key={label}
              type="button"
              className={`atl-link${current ? ' is-current' : ''}`}
              aria-current={current ? 'page' : undefined}
              onClick={run(action)}
            >
              {label}
            </button>
          ))}
          <button type="button" className="atl-link atl-nav-menu-signin" onClick={run(onSignIn)}>
            Sign in
          </button>
        </div>
        <div className="atl-nav-actions">
          <button type="button" className="atl-link atl-muted atl-nav-signin" onClick={onSignIn}>Sign in</button>
          <button type="button" className="atl-link atl-btn" onClick={onStartDesigning}>Get started</button>
          <button
            type="button"
            className="atl-link atl-burger"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="atl-nav-menu"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>
    </nav>
  );
};

export const AtelierFooter = ({ onAbout, onPricing, onHelp, onPrivacy }) => (
  <footer className="atl-footer">
    <span>© {new Date().getFullYear()} Fashdeck · Made in India</span>
    <div className="atl-footer-links">
      {onAbout && <button type="button" className="atl-link" onClick={onAbout}>About</button>}
      <button type="button" className="atl-link" onClick={onPricing}>Pricing</button>
      <button type="button" className="atl-link" onClick={onHelp}>Help</button>
      <button type="button" className="atl-link" onClick={onPrivacy}>Privacy</button>
    </div>
  </footer>
);
